import i18n from "@/i18n/config";

const FILE_SIZE_UNITS = ["bytes", "KB", "MB", "GB", "TB"] as const;

interface FormatFileSizeOptions {
  unknownLabel?: string;
}

function unitLabel(unitIndex: number): string {
  return unitIndex === 0 ? i18n.t("common:bytes") : FILE_SIZE_UNITS[unitIndex];
}

export function formatFileSize(
  bytes: number | null | undefined,
  options: FormatFileSizeOptions = {},
): string {
  const unknownLabel = options.unknownLabel ?? i18n.t("common:unknownSize");

  if (bytes == null) {
    return unknownLabel;
  }

  if (!Number.isFinite(bytes)) {
    return unknownLabel;
  }

  const absBytes = Math.abs(bytes);
  if (absBytes === 0) {
    return `0 ${i18n.t("common:bytes")}`;
  }

  const unitIndex = Math.max(
    0,
    Math.min(
      Math.floor(Math.log(absBytes) / Math.log(1000)),
      FILE_SIZE_UNITS.length - 1,
    ),
  );
  const formattedValue = (bytes / Math.pow(1000, unitIndex)).toFixed(2);

  return `${formattedValue} ${unitLabel(unitIndex)}`;
}

export function formatUploadSpeed(bytesPerSecond: number): string {
  return `${formatFileSize(bytesPerSecond)}/s`;
}

export function getFileExtension(filename: string): string {
  const extensionStart = filename.lastIndexOf(".");
  if (extensionStart === -1) {
    return "";
  }

  return filename.slice(extensionStart).toLowerCase();
}
